// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ds-disciplines-section {
  padding: 0;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  height: auto;
  min-height: auto
}

.ds-disciplines-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
}

.ds-view-tabs {
  display: flex;
  background: #f8fafc;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
  max-width: 100%;
}

.ds-view-tab {
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
}

.ds-view-tab.ds-active {
  background: #002FA7;
  color: white;
}

.ds-view-tab:hover:not(.ds-active) {
  background: #e2e8f0;
  color: #002FA7;
}

.ds-disciplines-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  overflow-x: hidden;
}

/* Стили для вкладки "По семестрам" */
.ds-semester-controls {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  max-width: 100%;
}

.ds-semester-tabs {
  display: flex;
  background: #f8fafc;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 2px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

.ds-semester-tab {
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
}

.ds-semester-tab.ds-active {
  background: #002FA7;
  color: white;
}

.ds-semester-tab:hover:not(.ds-active) {
  background: #e2e8f0;
  color: #002FA7;
}

/* Стили для вкладки "По курсу" */
.ds-course-controls {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  max-width: 100%;
}

.ds-course-tabs {
  display: flex;
  background: #f8fafc;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 2px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
}

.ds-course-tab {
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
  flex: 1 1;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
}

.ds-course-tab.ds-active {
  background: #002FA7;
  color: white;
}

.ds-course-tab:hover:not(.ds-active) {
  background: #e2e8f0;
  color: #002FA7;
}

.ds-disciplines-table-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.ds-disciplines-table {
  width: auto;
  min-width: 100%;
  border-collapse: collapse;
  background: white;
  table-layout: fixed;
}

.ds-disciplines-table th {
  background: #f8fafc;
  color: #002c9c;
  font-size: 14px;
  font-weight: 500;
  padding: 16px 8px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  min-width: 20px;
  height: 60px;
  vertical-align: middle;
}

.ds-disciplines-table td {
  padding: 16px 8px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
  font-size: 14px;
  transition: all 0.3s ease;
  min-width: 40px;
  word-break: break-word;
  vertical-align: middle;
}

/* Стили для заголовков с переносами */
.ds-header-text {
  text-align: center;
  line-height: 1.2;
  white-space: normal;
  word-break: break-word;
}

/* Стили для колонок таблицы */
.ds-number-column {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
}

.ds-subject-column {
  min-width: 200px;
  text-align: left;
}

.ds-course-column {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
}

.ds-groups-column {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
}

.ds-attendance-column {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}

.ds-number-cell {
  text-align: center;
  color: #64748b;
  font-weight: 500;
}

.ds-subject-name {
  color: #002FA7;
  font-weight: 500;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.ds-course-cell {
  text-align: center;
  color: #1e293b;
  font-weight: 500;
}

.ds-groups-cell {
  text-align: center;
  color: #1e293b;
  font-weight: 500;
}

.ds-percent-bubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 70px;
  height: 32px;
  padding: 0 12px;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: default;
}

.ds-column-header {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
}

.ds-sort-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.ds-sort-button:hover {
  background-color: #e2e8f0;
}

.ds-sort-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

.ds-sort-desc {
  transform: rotate(180deg);
}

/* Выделение строки */

.ds-discipline-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ds-discipline-row:hover {
  background-color: #f8fafc;
}

.ds-discipline-row.ds-selected {
  background-color: #f0f7ff;
  border-left: 3px solid #002FA7;
}


/* Стили для заголовка дисциплин */
.ds-cabinet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
}

.ds-cache-warning {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
  color: #856404;
  font-size: 14px;
}

.ds-error-message {
  background: #fed7d7;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 16px 0;
  border-left: 4px solid #c53030;
  text-align: center;
}


/* Стили для блока фильтра по дисциплине в DisciplinesSection */
.ds-discipline-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  margin-bottom: 24px;
  background: transparent;
  border-left: none;
  border-radius: 0;
  height: auto;
}

.ds-discipline-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

.ds-discipline-name {
  font-size: 18px;
  color: #002FA7;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.8);
  padding: 8px 16px;
  border-radius: 8px;
  border-left: 4px solid #002FA7;
}

/* Кнопка сброса фильтра */
.ds-clear-discipline {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  color: #374151;
  padding: 12px 24px;
  border-radius: 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  max-width: 200px;
  min-width: 200px;
  justify-content: center;
}

.ds-clear-discipline:hover {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
  color: #002FA7;
}

.ds-clear-discipline:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.pc-refresh-btn {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pc-refresh-btn.pc-refreshing {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-color: #cbd5e1;
  color: #64748b;
  cursor: not-allowed;
}

.pc-refresh-icon {
  width: 22px;
  height: 22px;
  transition: all 0.3s ease;
  filter: brightness(0.8);
}

.pc-refresh-spin {
  animation: pc-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  filter: brightness(1);
}

@keyframes pc-spin {
  0% { 
    transform: rotate(0deg);
    filter: brightness(0.8);
  }
  50% {
    filter: brightness(1.2);
  }
  100% { 
    transform: rotate(360deg);
    filter: brightness(0.8);
  }
}

/* Эффект пульсации для кнопки во время обновления */
.pc-refresh-btn.pc-refreshing::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Адаптивность для фильтра */
@media (max-width: 768px) {
  .ds-discipline-filter {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .ds-discipline-info {
    justify-content: center;
    text-align: center;
  }
  
  .ds-clear-discipline {
    max-width: 100%;
    min-width: auto;
    width: 100%;
  }
}

/* Адаптивность для планшетов (768px - 1024px) */
@media (max-width: 1024px) {
  .ds-disciplines-table th,
  .ds-disciplines-table td {
    padding: 12px 6px;
    font-size: 13px;
  }
  
  .ds-view-tab,
  .ds-semester-tab,
  .ds-course-tab {
    padding: 6px 8px;
    font-size: 13px;
  }
  
  .ds-subject-name {
    min-width: 150px;
    font-size: 13px;
  }
  
  .ds-percent-bubble {
    min-width: 60px;
    height: 28px;
    font-size: 12px;
  }

  .ds-disciplines-table th {
    height: 50px;
    font-size: 12px;
  }
}

/* Адаптивность для мобильных устройств (768px и меньше) */
@media (max-width: 768px) {
  .ds-disciplines-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  
  .ds-view-tabs {
    width: 100%;
  }
  
  .ds-view-tab {
    padding: 6px 8px;
    font-size: 12px;
    min-width: 0;
  }
  
  .ds-disciplines-table th,
  .ds-disciplines-table td {
    padding: 10px 4px;
    font-size: 12px;
  }
  
  .ds-subject-name {
    min-width: 120px;
    font-size: 12px;
  }
  
  .ds-semester-tabs,
  .ds-course-tabs {
    width: 100%;
  }
  
  .ds-semester-tab,
  .ds-course-tab {
    padding: 6px 8px;
    font-size: 12px;
    min-width: 0;
  }
  
  .ds-percent-bubble {
    min-width: 50px;
    height: 24px;
    font-size: 11px;
    padding: 0 8px;
  }

  .ds-disciplines-table th {
    height: 45px;
    font-size: 11px;
  }

  .ds-number-column {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
  }

  .ds-course-column {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
  }

  .ds-groups-column {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
  }

  .ds-attendance-column {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
  }
}

/* Адаптивность для маленьких мобильных устройств (480px и меньше) */
@media (max-width: 480px) {
  .ds-disciplines-table th,
  .ds-disciplines-table td {
    padding: 8px 3px;
    font-size: 10px;
  }

  .ds-view-tab {
    padding: 5px 6px;
    font-size: 10px;
  }
  
  .ds-semester-tab,
  .ds-course-tab {
    padding: 5px 6px;
    font-size: 10px;
  }
  
  .ds-subject-name {
    min-width: 100px;
    font-size: 10px;
  }
  
  .ds-percent-bubble {
    min-width: 40px;
    height: 20px;
    font-size: 9px;
    padding: 0 6px;
    border-radius: 4px;
  }

  .ds-disciplines-table th {
    height: 40px;
    font-size: 9px;
  }

  .ds-header-text {
    line-height: 1.1;
  }
}

/* Адаптивность для очень маленьких устройств (360px и меньше) */
@media (max-width: 360px) {
  .ds-disciplines-table th,
  .ds-disciplines-table td {
    padding: 6px 2px;
    font-size: 9px;
  }
  
  .ds-view-tab {
    padding: 4px 4px;
    font-size: 9px;
  }
  
  .ds-semester-tab,
  .ds-course-tab {
    padding: 4px 4px;
    font-size: 9px;
  }
  
  .ds-subject-name {
    min-width: 80px;
    font-size: 9px;
  }
  
  .ds-percent-bubble {
    min-width: 35px;
    height: 18px;
    font-size: 8px;
    padding: 0 4px;
  }

  .ds-disciplines-table th {
    height: 35px;
    font-size: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/th-components/DisciplinesSectionStyle.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;;AAErB;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;;AAGA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;;;AAGA,+DAA+D;AAC/D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;EACb;AACF;;AAEA,gDAAgD;AAChD;EACE;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,oEAAoE;AACpE;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,gEAAgE;AAChE;EACE;;IAEE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":[".ds-disciplines-section {\n  padding: 0;\n  background: transparent;\n  width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  height: auto;\n  min-height: auto\n}\n\n.ds-disciplines-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  gap: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.ds-view-tabs {\n  display: flex;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.ds-view-tab {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.ds-view-tab.ds-active {\n  background: #002FA7;\n  color: white;\n}\n\n.ds-view-tab:hover:not(.ds-active) {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n.ds-disciplines-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\n/* Стили для вкладки \"По семестрам\" */\n.ds-semester-controls {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.ds-semester-tabs {\n  display: flex;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 2px;\n  min-width: 0;\n  max-width: 100%;\n  width: 100%;\n}\n\n.ds-semester-tab {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.ds-semester-tab.ds-active {\n  background: #002FA7;\n  color: white;\n}\n\n.ds-semester-tab:hover:not(.ds-active) {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n/* Стили для вкладки \"По курсу\" */\n.ds-course-controls {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.ds-course-tabs {\n  display: flex;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 4px;\n  border: 1px solid #e2e8f0;\n  flex-wrap: wrap;\n  gap: 2px;\n  min-width: 0;\n  max-width: 100%;\n  width: 100%;\n}\n\n.ds-course-tab {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.ds-course-tab.ds-active {\n  background: #002FA7;\n  color: white;\n}\n\n.ds-course-tab:hover:not(.ds-active) {\n  background: #e2e8f0;\n  color: #002FA7;\n}\n\n.ds-disciplines-table-container {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ds-disciplines-table {\n  width: auto;\n  min-width: 100%;\n  border-collapse: collapse;\n  background: white;\n  table-layout: fixed;\n}\n\n.ds-disciplines-table th {\n  background: #f8fafc;\n  color: #002c9c;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 16px 8px;\n  text-align: center;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n  min-width: 20px;\n  height: 60px;\n  vertical-align: middle;\n}\n\n.ds-disciplines-table td {\n  padding: 16px 8px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #1e293b;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  min-width: 40px;\n  word-break: break-word;\n  vertical-align: middle;\n}\n\n/* Стили для заголовков с переносами */\n.ds-header-text {\n  text-align: center;\n  line-height: 1.2;\n  white-space: normal;\n  word-break: break-word;\n}\n\n/* Стили для колонок таблицы */\n.ds-number-column {\n  width: 50px;\n  min-width: 50px;\n  max-width: 50px;\n}\n\n.ds-subject-column {\n  min-width: 200px;\n  text-align: left;\n}\n\n.ds-course-column {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n}\n\n.ds-groups-column {\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n}\n\n.ds-attendance-column {\n  width: 140px;\n  min-width: 140px;\n  max-width: 140px;\n}\n\n.ds-number-cell {\n  text-align: center;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.ds-subject-name {\n  color: #002FA7;\n  font-weight: 500;\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: left;\n}\n\n.ds-course-cell {\n  text-align: center;\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.ds-groups-cell {\n  text-align: center;\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.ds-percent-bubble {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 70px;\n  height: 32px;\n  padding: 0 12px;\n  color: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: default;\n}\n\n.ds-column-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-start;\n}\n\n.ds-sort-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.ds-sort-button:hover {\n  background-color: #e2e8f0;\n}\n\n.ds-sort-icon {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n}\n\n.ds-sort-desc {\n  transform: rotate(180deg);\n}\n\n/* Выделение строки */\n\n.ds-discipline-row {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.ds-discipline-row:hover {\n  background-color: #f8fafc;\n}\n\n.ds-discipline-row.ds-selected {\n  background-color: #f0f7ff;\n  border-left: 3px solid #002FA7;\n}\n\n\n/* Стили для заголовка дисциплин */\n.ds-cabinet-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 16px;\n}\n\n.ds-cache-warning {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  color: #856404;\n  font-size: 14px;\n}\n\n.ds-error-message {\n  background: #fed7d7;\n  color: #c53030;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin: 16px 0;\n  border-left: 4px solid #c53030;\n  text-align: center;\n}\n\n\n/* Стили для блока фильтра по дисциплине в DisciplinesSection */\n.ds-discipline-filter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px;\n  margin-bottom: 24px;\n  background: transparent;\n  border-left: none;\n  border-radius: 0;\n  height: auto;\n}\n\n.ds-discipline-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n.ds-discipline-name {\n  font-size: 18px;\n  color: #002FA7;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 8px 16px;\n  border-radius: 8px;\n  border-left: 4px solid #002FA7;\n}\n\n/* Кнопка сброса фильтра */\n.ds-clear-discipline {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 2px solid #e2e8f0;\n  color: #374151;\n  padding: 12px 24px;\n  border-radius: 16px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  max-width: 200px;\n  min-width: 200px;\n  justify-content: center;\n}\n\n.ds-clear-discipline:hover {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);\n  color: #002FA7;\n}\n\n.ds-clear-discipline:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n.pc-refresh-btn {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.pc-refresh-btn.pc-refreshing {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-color: #cbd5e1;\n  color: #64748b;\n  cursor: not-allowed;\n}\n\n.pc-refresh-icon {\n  width: 22px;\n  height: 22px;\n  transition: all 0.3s ease;\n  filter: brightness(0.8);\n}\n\n.pc-refresh-spin {\n  animation: pc-spin 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  filter: brightness(1);\n}\n\n@keyframes pc-spin {\n  0% { \n    transform: rotate(0deg);\n    filter: brightness(0.8);\n  }\n  50% {\n    filter: brightness(1.2);\n  }\n  100% { \n    transform: rotate(360deg);\n    filter: brightness(0.8);\n  }\n}\n\n/* Эффект пульсации для кнопки во время обновления */\n.pc-refresh-btn.pc-refreshing::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.4),\n    transparent\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Адаптивность для фильтра */\n@media (max-width: 768px) {\n  .ds-discipline-filter {\n    flex-direction: column;\n    gap: 12px;\n    align-items: stretch;\n  }\n  \n  .ds-discipline-info {\n    justify-content: center;\n    text-align: center;\n  }\n  \n  .ds-clear-discipline {\n    max-width: 100%;\n    min-width: auto;\n    width: 100%;\n  }\n}\n\n/* Адаптивность для планшетов (768px - 1024px) */\n@media (max-width: 1024px) {\n  .ds-disciplines-table th,\n  .ds-disciplines-table td {\n    padding: 12px 6px;\n    font-size: 13px;\n  }\n  \n  .ds-view-tab,\n  .ds-semester-tab,\n  .ds-course-tab {\n    padding: 6px 8px;\n    font-size: 13px;\n  }\n  \n  .ds-subject-name {\n    min-width: 150px;\n    font-size: 13px;\n  }\n  \n  .ds-percent-bubble {\n    min-width: 60px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .ds-disciplines-table th {\n    height: 50px;\n    font-size: 12px;\n  }\n}\n\n/* Адаптивность для мобильных устройств (768px и меньше) */\n@media (max-width: 768px) {\n  .ds-disciplines-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n  \n  .ds-view-tabs {\n    width: 100%;\n  }\n  \n  .ds-view-tab {\n    padding: 6px 8px;\n    font-size: 12px;\n    min-width: 0;\n  }\n  \n  .ds-disciplines-table th,\n  .ds-disciplines-table td {\n    padding: 10px 4px;\n    font-size: 12px;\n  }\n  \n  .ds-subject-name {\n    min-width: 120px;\n    font-size: 12px;\n  }\n  \n  .ds-semester-tabs,\n  .ds-course-tabs {\n    width: 100%;\n  }\n  \n  .ds-semester-tab,\n  .ds-course-tab {\n    padding: 6px 8px;\n    font-size: 12px;\n    min-width: 0;\n  }\n  \n  .ds-percent-bubble {\n    min-width: 50px;\n    height: 24px;\n    font-size: 11px;\n    padding: 0 8px;\n  }\n\n  .ds-disciplines-table th {\n    height: 45px;\n    font-size: 11px;\n  }\n\n  .ds-number-column {\n    width: 40px;\n    min-width: 40px;\n    max-width: 40px;\n  }\n\n  .ds-course-column {\n    width: 60px;\n    min-width: 60px;\n    max-width: 60px;\n  }\n\n  .ds-groups-column {\n    width: 80px;\n    min-width: 80px;\n    max-width: 80px;\n  }\n\n  .ds-attendance-column {\n    width: 100px;\n    min-width: 100px;\n    max-width: 100px;\n  }\n}\n\n/* Адаптивность для маленьких мобильных устройств (480px и меньше) */\n@media (max-width: 480px) {\n  .ds-disciplines-table th,\n  .ds-disciplines-table td {\n    padding: 8px 3px;\n    font-size: 10px;\n  }\n\n  .ds-view-tab {\n    padding: 5px 6px;\n    font-size: 10px;\n  }\n  \n  .ds-semester-tab,\n  .ds-course-tab {\n    padding: 5px 6px;\n    font-size: 10px;\n  }\n  \n  .ds-subject-name {\n    min-width: 100px;\n    font-size: 10px;\n  }\n  \n  .ds-percent-bubble {\n    min-width: 40px;\n    height: 20px;\n    font-size: 9px;\n    padding: 0 6px;\n    border-radius: 4px;\n  }\n\n  .ds-disciplines-table th {\n    height: 40px;\n    font-size: 9px;\n  }\n\n  .ds-header-text {\n    line-height: 1.1;\n  }\n}\n\n/* Адаптивность для очень маленьких устройств (360px и меньше) */\n@media (max-width: 360px) {\n  .ds-disciplines-table th,\n  .ds-disciplines-table td {\n    padding: 6px 2px;\n    font-size: 9px;\n  }\n  \n  .ds-view-tab {\n    padding: 4px 4px;\n    font-size: 9px;\n  }\n  \n  .ds-semester-tab,\n  .ds-course-tab {\n    padding: 4px 4px;\n    font-size: 9px;\n  }\n  \n  .ds-subject-name {\n    min-width: 80px;\n    font-size: 9px;\n  }\n  \n  .ds-percent-bubble {\n    min-width: 35px;\n    height: 18px;\n    font-size: 8px;\n    padding: 0 4px;\n  }\n\n  .ds-disciplines-table th {\n    height: 35px;\n    font-size: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
